import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store';
import { useAppSelector } from 'store';
import { getUserDetails } from 'store/thunk/authThunk';

function PrivateRoute(props) {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const setUserData = useAppSelector((state) => state.authorization);
  const userData = setUserData?.userData?.data;
  const setUserDataNew = setUserData?.userDetails;
  const myParam = urlParams.get('success');
  const dispatch = useAppDispatch();
  const { children } = props;
  useEffect(() => {
    if (userData) {
      let request = {
        id: userData?.id
      };
      dispatch(getUserDetails(request));
    }
  }, [children]);

  useEffect(() => {
    if (setUserDataNew?.data) {
      if (myParam == 'true') {
        const currentLocalStorageData = JSON.parse(localStorage.getItem('user_data'));
        const updatedData = {
          ...currentLocalStorageData,
          data: setUserDataNew?.data // Replace 'updatedUserData' with your updated data
        };
        localStorage.setItem('user_data', JSON.stringify(updatedData));
      }
    }
  }, [setUserDataNew, myParam]);

  useEffect(() => {
    if (
      setUserDataNew?.data?.user_type == 2 &&
      setUserDataNew?.data?.is_subscribed == false &&
      !setUserDataNew?.data?.email.includes('@sellcord.co')
    ) {
      navigate('/account-settings');
    }
  }, [setUserDataNew, children]);
  const userAuthData = useAppSelector((state) => state.authorization);
  return userAuthData.userData ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
